/**
 * 商品中心-商品： 书本来源系统
 */
export const BockSourceSelectOption = [
  { value: 1, label: '供应商协同平台' },
  { value: 2, label: '三方系统' },
  { value: 3, label: '编目系统' },
  { value: 4, label: 'ERP销售中心' },
  { value: 5, label: 'ERP采购中心' },
  { value: 6, label: 'ERP商品中心编目新建' },
  { value: 7, label: 'ERP商品中心预编目新建' },
  { value: 8, label: 'ERP商品中心自编新建' },
  { value: 9, label: '其他' },
  // { value: 100, label: '全部' },
]

export enum BookCategoryType {
  REGULAR = 1, // 普通图书
  TEXTBOOK = 2, // 教材
  PICTURE_LOOSE_LEAF = 3, // 图片活页
  MAGAZINE = 4, // 期刊杂志
  IMPORTED_BOOK = 5, // 进口图书
}

export enum BookCategoryTypeName {
  REGULAR = '普通图书',
  TEXTBOOK = '教材',
  PICTURE_LOOSE_LEAF = '图片活页',
  MAGAZINE = '期刊杂志',
  IMPORTED_BOOK = '进口图书',
}
